import React, { useState, useRef, useEffect } from 'react';
import { func, number, string } from 'prop-types';
import classNames from 'classnames';

import css from './Handle.module.css';

function Handle(props) {
  const [dragging, setDragging] = useState(false);
  const [_relativePos, setRelativePos] = useState(null);
  const handleRef = useRef(null);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    const onMouseMove = e => {
      if (!dragging) return;
      onMove(e.pageX);
    };
    const onMouseUp = e => {
      e.stopPropagation();
      e.preventDefault();
      onEnd();
    };
    window.addEventListener('mousemove', onMouseMove, false);
    window.addEventListener('mouseup', onMouseUp, false);
    return () => {
      isMounted.current = false;
      window.removeEventListener('mousemove', onMouseMove, false);
      window.removeEventListener('mouseup', onMouseUp, false);
    };
  }, [dragging]);

  const onStart = x => {
    setDragging(true);
    setRelativePos(x);
  };
  const onMove = x => {
    if (!dragging) return;
    setRelativePos(x);
  };
  const onEnd = () => {
    setDragging(false);
    setRelativePos(null);
  };
  const onMouseDown = e => {
    e.stopPropagation();
    e.preventDefault();
    onStart(e.pageX);
  };
  const onTouchStart = e => {
    e.stopPropagation();
    e.preventDefault();
    onStart(e.touches[0].pageX);
  };

  const { rootClassName = null, className = null, value, valueToPosition } = props;
  const position = valueToPosition(value);
  const classes = classNames(rootClassName || css.rootTouchBuffer, className);

  return (
    <div
      className={classes}
      ref={handleRef}
      style={{ left: `${position}px` }}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      role="button"
    >
      <div
        className={classNames(css.visibleHandle, {
          [css.dragged]: dragging,
        })}
      />
    </div>
  );
}

Handle.propTypes = {
  rootClassName: string,
  className: string,
  min: number.isRequired,
  max: number.isRequired,
  valueToPosition: func.isRequired,
  positionToValue: func.isRequired,
};

export default Handle;
